import React, { Component } from 'react';
import axios from 'axios';
import InputField from '../../components/fields.component';
import { Modal, Form } from 'react-bootstrap';
import Spinner from '../../components/spinner.component';
import {MSG, allowedSize, allowedMimeTypes} from  '../../constants';

class ThirdParty extends Component {
	state = {
		formErrors: [],
		formData: {
			workspace_id: 5,
			first_name: { value: "", id: null, field_type: "", show: true },
			last_name: { value: "", id: null, field_type: "", show: true },
			mobile: { value: "", id: null, field_type: "", show: true },
			employee_id: { value: "", id: null, field_type: "", show: true },
			requester: { value: "", id: null, field_type: "", show: true },
			main_category_alumni_or_former_member_of_emapta: { value: "", id: null, field_type: "", show: true },
			ticket_info: null,
			file: null,
			description: { label: "Description", value: "", id: null, field_type: "", show: true },
		},
		isAttachmentRequired: true,
		attachmentMessages: [],
		formFields: [],
		formStatus: {
			submitted: false
		},
		submitModal: {
			show: false
		},
		formErrorModal: {
			show: false,
			message: []
		},
		requiredFieldModal: {
			show: false,
		},
		page: {
			loaded: false
		}
	}


	componentDidMount = async () => {
		let { page, formData, formFields } = this.state;

		let fieldRequest = await this.getFields();

		if (fieldRequest.status) {

			fieldRequest.data.map(field => {

				formFields.push({
					name: field.name,
					label_for_customers: field.label_for_customers,
					belongs_to_section: field.belongs_to_section,
					choices: field.choices,
					default_field: field.default_field,
					description: field.description,
					displayed_to_customers: field.displayed_to_customers,
					field_type: field.field_type,
					field_id: field.field_id,
					id: field.id,
					nested_fields: field.nested_fields,
					position: field.position,
					required_for_customers: field.required_for_customers,
					sections: field.sections,
				})
			});

			formFields.push({
				file: null
			});

			Object.keys(formData).map(key => {
				if (!['workspace_id', 'file', 'ticket_info'].includes(key)) {
					let field = formFields.find(form => form.name === key);
					if (field) {
						formData[key].id = field.id;
						formData[key].field_type = field.field_type;
					}
				}
			})

			page.loaded = true;
		}
		this.setState({ ...this.state, page, formData, formFields });
	}

	getFields = async () => {
		let request = await axios.get(`/api/tickets/get-fields?workspace=7`);
		return request.data;
	}

	inputChangeHandler = e => {
		let { formData, formErrors, formFields, attachmentMessages } = this.state
		attachmentMessages = [];
		formData[e.target.name].value = e.target.value;

		let removeTicketInfoFields = [];
		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}

		//set second level
		if (["main_category_alumni_or_former_member_of_emapta"].includes(e.target.name)) {
			formData.ticket_info = {}
			if (["certifications"].includes(e.target.value.toLowerCase())) {
				attachmentMessages = ["Proof of identification (Valid ID) as requestor"];

				//show Certifications Sub Category
				//certification_main_category
				let findField = formFields.find(field => field.name === "certifications_sub_category_alumni_or_former_member_of_emapta");
				if (findField) {
					formData.ticket_info[findField.name] = {};
					formData.ticket_info[findField.name].id = findField.id;
					formData.ticket_info[findField.name].field_type = findField.field_type;
					formData.ticket_info[findField.name].value = "";
				}
			}

			if (["work related information"].includes(e.target.value.toLowerCase())) {

				attachmentMessages = ["Proof of final pay breakdown"];

				//show Certifications Sub Category
				//certification_main_category
				let findField = formFields.find(field => field.name === "work_related_information_sub_category_alumni_or_former_member_of_emapta");
				if (findField) {
					formData.ticket_info[findField.name] = {};
					formData.ticket_info[findField.name].id = findField.id;
					formData.ticket_info[findField.name].field_type = findField.field_type;
					formData.ticket_info[findField.name].value = "";
				}
			}
		}

		this.setState({ ...this.state, formData, formErrors, attachmentMessages });
	}

	ticketInfoChangeHandler = (e) => {
		let { formData, formErrors, formFields } = this.state
		let removeFields = [];
		let additionalFields = [];
		formData.ticket_info[e.target.name].value = e.target.value;

		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}
		// console.log(149, e.target.name, e.target.value);
		if (["certifications_sub_category_alumni_or_former_member_of_emapta"].includes(e.target.name)) {
			//display topics or concern

			// let certificateMainCategoryField = formFields.find(field => field.name === "certification_main_category");
			// if (certificateMainCategoryField) {
			// 	//find Certifications Topics or Concern and add
			// 	let findCertificationsTopicsOrConcern = certificateMainCategoryField.nested_fields.find(field => field.name === "certification_sub_category");
			// 	if (findCertificationsTopicsOrConcern) {
			// 		formData.ticket_info[findCertificationsTopicsOrConcern.name] = {};
			// 		formData.ticket_info[findCertificationsTopicsOrConcern.name].id = findCertificationsTopicsOrConcern.id;
			// 		formData.ticket_info[findCertificationsTopicsOrConcern.name].field_type = "custom_dropdown";
			// 		formData.ticket_info[findCertificationsTopicsOrConcern.name].value = "";
			// 	}
			// }
		}

		if (["work_related_information_sub_category_alumni_or_former_member_of_emapta"].includes(e.target.name)) {

			additionalFields = ["full_name_of_employee", "location", "client_or_program", "department_or_division", "effective_date_of_separation"];

			//show Work Related Information Topics or Concern
			// let workRelatedInformationCategory = formFields.find(field => field.name === "work_related_information_category");
			// if (workRelatedInformationCategory) {
			// 	//find Certifications Topics or Concern and add
			// 	let findWorkRelatedInformationTopicsOrConcern = workRelatedInformationCategory.nested_fields.find(field => field.name === "work_related_information_sub_category");
			// 	if (findWorkRelatedInformationTopicsOrConcern) {
			// 		formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name] = {};
			// 		formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name].id = findWorkRelatedInformationTopicsOrConcern.id;
			// 		formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name].field_type = "custom_dropdown";
			// 		formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name].value = "";
			// 	}
			// }
		}

		// if (["work_related_information_sub_category"].includes(e.target.name)) {
		// 	let workRelatedInformationCategory = formFields.find(field => field.name === "work_related_information_category");
		// 	if (workRelatedInformationCategory) {
		// 		//find Certifications Topics or Concern and add
		// 		let findWorkRelatedInformationTopicsOrConcern = workRelatedInformationCategory.nested_fields.find(field => field.name === "work_related_information_cause_of_concern");
		// 		if (findWorkRelatedInformationTopicsOrConcern) {
		// 			formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name] = {};
		// 			formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name].id = findWorkRelatedInformationTopicsOrConcern.id;
		// 			formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name].field_type = "custom_dropdown";
		// 			formData.ticket_info[findWorkRelatedInformationTopicsOrConcern.name].value = "";
		// 		}
		// 	}
		// }


		if (additionalFields && additionalFields.length > 0) {
			additionalFields.map(field => {
				let findFields = formFields.find(form => form.name === field)
				if (findFields) {
					formData.ticket_info[findFields.name] = {};
					formData.ticket_info[findFields.name].id = findFields.id;
					formData.ticket_info[findFields.name].field_type = findFields.field_type;
					formData.ticket_info[findFields.name].value = "";
				}
			})
		}

		removeFields.map(removeField => {
			if (formData.ticket_info.hasOwnProperty(removeField)) {
				delete formData.ticket_info[removeField]
			}
		})


		this.setState({ ...this.state, formData, formErrors });
	}

	attachFileHandler = (e, fileIdx) => {
		let { formData, formErrors, formErrorModal } = { ...this.state };
		let files = e.target.files;

		let error = [];
		let fileTypeError = false;
		let  fileSize = 0;
		for (let i = 0; i < files.length; i++) {
			fileSize = fileSize + files[i].size; 
			if(!allowedMimeTypes.includes(files[i].type)) {
				fileTypeError= true;
			}

		}

		if(fileTypeError==true) {
			formErrorModal.show = true;
			formErrorModal.message = [];
			formErrorModal.message.push(<h3>{MSG.fileType.title}</h3>);
			formErrorModal.message.push(<p>{MSG.fileType.message}</p>);

		}else if (fileSize > allowedSize) {
			formErrorModal.show = true;
			formErrorModal.message = [];
			formErrorModal.message.push(<h3>{MSG.fileSize.title}</h3>);
			formErrorModal.message.push(<p>{MSG.fileSize.message}</p>);

		} else {
			if (formErrors.includes(`${fileIdx}_file`)) {
				let fIdx = formErrors.indexOf(`${fileIdx}_file`);
				formErrors.splice(fIdx, 1);
			}
			formData.file = files
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	removeAttachment = (e, idx) => {
		e.preventDefault();
		let formData = this.state.formData;
		formData.file = Array.from(formData.file);
		formData.file.splice(idx, 1);
		this.setState({ formData });
	}

	validateEmail = (email) => {
		return String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
			);
	};

	submitForm = e => {
		e.preventDefault();
		let { formData, formErrors, formStatus, isAttachmentRequired, requiredFieldModal } = this.state;

		formErrors = [];

		if (isAttachmentRequired) {
			if (!formData.file || formData.file.length <= 0) {
				if (!formErrors.includes('file')) formErrors.push("file");
			}
		}

		Object.keys(formData).map(key => {

			let findField = this.state.formFields.find(field => field.name === key);
			if (findField) {
				if (findField.required_for_customers && formData[key].value === '') formErrors.push(key);
			}

			if (key === "description") {
				if (formData[key].show === false) {
					formData[key].value = "no description needed";
				}
			}

			if (key === 'requester') {
				let isEmail = this.validateEmail(formData[key].value);
				if (!isEmail) {
					if (!formErrors.includes(key)) formErrors.push(key)
				}
			}
		})

		if (formData.ticket_info !== null) {
			Object.keys(formData.ticket_info).map(key => {

				let findField = this.state.formFields.find(field => field.name === key);
				if (findField) {
					if (findField.required_for_customers && formData.ticket_info[key].value === '') formErrors.push(key);
				} else {
					if ([22000007660].includes(formData.ticket_info[key].id)) {
						if (formData.ticket_info[key].value === '') formErrors.push(key);
					}
				}
			})
		}
		requiredFieldModal.show = formErrors.length > 0 ? true : false;
		formStatus.submitted = formErrors.length > 0 ? false : true;
		this.setState({ ...this.state, formErrors, formStatus, requiredFieldModal }, () => {
			if (this.state.formErrors.length < 1) this.sendForm()
		});
	}

	sendForm = () => {
		let formData = this.state.formData;
		let FD = new FormData();

		if (formData.file !== null) {
			for (const key of Object.keys(formData.file)) {
				FD.append('file', formData.file[key], formData.file[key].name);
			}
		}

		Object.keys(formData).map(key => {
			if (!['file', 'ticket_info'].includes(key)) {
				FD.append(key, JSON.stringify(formData[key]));
			}
		})

		if (formData.ticket_info !== null) {
			Object.keys(formData.ticket_info).map(key => {
				FD.append(key, JSON.stringify(formData.ticket_info[key]));
			})
		}

		return axios.post('/api/tickets', FD)
			.then(response => {
				let { formStatus, submitModal } = this.state
				formStatus.submitted = false;
				submitModal.show = true;
				return this.setState({ ...this.state, formStatus, submitModal });
			}).catch(err => {
				let { errors } = err.response.data;
				let { formStatus, formErrorModal } = { ...this.state }

				formErrorModal.show = true;
				formStatus.submitted = false;

				formErrorModal.message = [];
				formErrorModal.message.push(<h3>Form did not submit</h3>)

				if (errors.hasOwnProperty('errors') && errors.errors.length > 0) {
					errors.errors.map((error, idx) => {
						formErrorModal.message.push(<p key={idx}>{error.message}</p>);
					})
				}
				return this.setState({ ...this.state, formStatus });
			})

	}

	closeSubmitModal = e => {
		e.preventDefault();
		window.location.reload();
	}

	closeErrorModal = e => {
		e.preventDefault();
		let { formErrorModal } = this.state;
		formErrorModal.show = false;
		formErrorModal.message = "";
		this.setState({ ...this.state, formErrorModal });
	}

	closeRequiredFieldModal = e => {
		e.preventDefault();
		let { requiredFieldModal } = this.state;
		requiredFieldModal.show = false;
		requiredFieldModal.message = "";
		this.setState({ ...this.state, requiredFieldModal });
	}

	displayField = (field) => {
		let { formErrors, formStatus, formData } = this.state;
		let findField = this.state.formFields.find(formData => formData.name === field);

		if (formData.main_category_alumni_or_former_member_of_emapta.value === "Work Related Information") {
			if (findField.name === "description") {
				findField.label_for_customers = "Final pay concerns details";
				formData.description.show = true;
			}
		} else {
			formData.description.show = false;
			formData.description.value = "no description needed";
		}

		if (findField) return <InputField field={findField} value={formData[findField.name].value} show={formData[findField.name].show} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.inputChangeHandler(e)} />
		return null;
	}

	displayTicketInfo = (ticket_info) => {
		let { formErrors, formStatus, formData, formFields } = this.state;

		let elements = [];
		Object.keys(ticket_info).map((key, idx) => {
			let findField = this.state.formFields.find(formData => formData.name === key);

			if (findField) {
				elements.push(
					<>
						<div key={`${idx}_${key}`} className="col-12">
							<InputField className={null} field={findField} value={formData.ticket_info[key].value} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.ticketInfoChangeHandler(e)} />
						</div>
					</>
				)
			} else {
				//not found in fiendFields
				if (["certifications_sub_category_alumni_or_former_member_of_emapta"].includes(key)) {
					//find if from field of certification_main_category
					let findField = formFields.find(formData => formData.name === "certifications_sub_category_alumni_or_former_member_of_emapta");
					console.log(357, findField);
					if (findField) {
						let findChoice = findField.choices.find(choice => choice.value === formData.ticket_info[findField.name].value);
						console.log(377, findChoice);
						if (findChoice) {

							let customField = {
								name: "certifications_sub_category_alumni_or_former_member_of_emapta",
								field_type: "custom_dropdown",
								id: `${findField.id}_certifications_sub_category_alumni_or_former_member_of_emapta`,
								label_for_customers: formData.main_category_alumni_or_former_member_of_emapta.value + " Topics or Concern",
								required_for_customers: true,
								choices: findChoice.nested_options
							}

							elements.push(
								<>
									<div key={`${idx}_${key}`} className="col-12">
										<InputField className={null} field={customField} value={formData.ticket_info[key].value} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.ticketInfoChangeHandler(e)} />
									</div>
								</>
							)
						}

					}
				}

				if (["work_related_information_sub_category_alumni_or_former_member_of_emapta"].includes(key)) {
					let findField = formFields.find(formData => formData.name === "work_related_information_sub_category_alumni_or_former_member_of_emapta");
					if (findField) {
						let findChoice = findField.choices.find(choice => choice.value === formData.ticket_info[findField.name].value);
						if (findChoice) {

							let customField = {
								name: "work_related_information_sub_category_alumni_or_former_member_of_emapta",
								field_type: "custom_dropdown",
								id: `${findField.id}work_related_information_sub_category_alumni_or_former_member_of_emapta`,
								label_for_customers: formData.main_category_alumni_or_former_member_of_emapta.value + " Topics or Concern",
								required_for_customers: true,
								choices: findChoice.nested_options
							}

							elements.push(
								<>
									<div key={`${idx}_${key}`} className="col-12">
										<InputField className={null} field={customField} value={formData.ticket_info[key].value} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.ticketInfoChangeHandler(e)} />
									</div>
								</>
							)
						}

					}
				}
				if (["work_related_information_topics_or_concern_alumni_or_former_member_of_emapta"].includes(key)) {
					let findField = formFields.find(formData => formData.name === "work_related_information_sub_category_alumni_or_former_member_of_emapta");
					if (findField) {
						let findChoice = findField.choices.find(choice => choice.value === formData.ticket_info[findField.name].value);
						if (findChoice) {

							let findNestedOption = findChoice.nested_options.find(choice => choice.value === formData.ticket_info["work_related_information_sub_category_alumni_or_former_member_of_emapta"].value);

							if (findNestedOption) {
								let customField = {
									name: "work_related_information_topics_or_concern_alumni_or_former_member_of_emapta",
									field_type: "custom_dropdown",
									id: `${findField.id}work_related_information_topics_or_concern_alumni_or_former_member_of_emapta`,
									label_for_customers: formData.main_category_alumni_or_former_member_of_emapta.value + " Topics of Concern",
									required_for_customers: true,
									choices: findNestedOption.nested_options
								}

								elements.push(
									<>
										<div key={`${idx}_${key}`} className="col-12">
											<InputField className={null} field={customField} value={formData.ticket_info["work_related_information_topics_or_concern_alumni_or_former_member_of_emapta"].value} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.ticketInfoChangeHandler(e)} />
										</div>
									</>
								)
							}
						}

					}
				}


			}
		})

		return elements;
	}

	displayAttachedFiles = () => {
		let formData = this.state.formData;

		let data = [];


		if (formData.file.length > 0) {

			for (let i = 0; i < formData.file.length; i++) {
				data.push(
					<div className="chip" key={i}>
						<span>{formData.file[i].name}</span>
						<a
							href="#"
							className="close"
							onClick={e => this.removeAttachment(e, i)}
						>
							<i className="bi bi-x"></i>
						</a>
					</div>
				)
			}
		}

		return data;
	}

	render() {
		let { formData, formStatus, submitModal, formErrorModal, page, formErrors, attachmentMessages, requiredFieldModal } = this.state;

		return page.loaded ? (
			<>
				<h4 style={{ color: '#ffffff' }}>
					In order for us to address your concerns accurately and efficiently, we kindly request that you provide us with the following information. This will enable us to expedite our response to your concern.
				</h4>

				<div className='row'>
					<div className="col-lg-6 col-md-6 col-xs-12">
						{this.displayField("first_name")}
					</div>
					<div className="col-lg-6 col-md-6 col-xs-12">
						{this.displayField("last_name")}
					</div>

					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("mobile")}
					</div>


					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("employee_id")}
					</div>

					<div className="col-12 col-xs-12 mt-3">
						{this.displayField("requester")}
					</div>
				</div>

				<div className='row' style={{ marginBottom: '50px' }}>
					<h4 style={{ marginTop: '50px', color: '#ffffff' }}>How can we help you today?</h4>

					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("main_category_alumni_or_former_member_of_emapta")}
					</div>

					{formData.ticket_info !== null ?
						this.displayTicketInfo(formData.ticket_info)
						: null
					}

					<div className="col-lg-12 col-md-12 col-xs-12 mt-3">
						{this.displayField("description")}
					</div>

					<div className="col-12">
						{attachmentMessages.length > 0 ?
							<>
								<label>Files to attach:  *</label>
								<p style={{ fontWeight: 'normal', marginTop: 10, marginBottom: 10, }}>
									<ul>
										{attachmentMessages.map((message, idx) => <li key={idx}>{message}</li>)}
									</ul>
								</p>
							</>
							:
							<label>Files  *</label>
						}

						<div className="file-upload ">
							<div className="file-upload-btn" >
								<label style={formErrors.includes(`file`) ? { borderColor: 'red' } : {}} >
									<i className="bi bi-paperclip"></i>
									Attach File
								</label>
								<input
									type="file"
									id="file"
									name='file'
									accept=".jpeg,.jpg,.gif,.png,.pdf,.doc,.docx,.xls,.xlsx,.csv"
									multiple
									className="form-control"
									onChange={e => this.attachFileHandler(e)}
									disabled={formStatus.submitted}
								/>
							</div>
							<span className="text-muted"><i>{MSG.general}</i></span>

							<div className="attach-chips">
								{formData.file !== null && this.displayAttachedFiles()}
							</div>
						</div>
					</div>
				</div>

				<div className="row action-btn">
					<div className="col-12">
						<button
							style={{ float: 'right' }}
							type="button"
							data-bs-toggle="modal"
							data-bs-target="#successModal"

							onClick={e => this.submitForm(e)}
							disabled={formStatus.submitted}
						>

							{formStatus.submitted ?
								<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> &nbsp; Submitting... </>
								:
								<>
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.91396 10L2.88989 16.0933L16.4333 10L2.88989 3.90673L4.91396 10ZM2.61324 10L0.0483426 17.7214C-0.228127 18.5537 0.733799 19.2809 1.59727 18.8925L19.3907 10.8871C20.2031 10.5216 20.2031 9.47843 19.3907 9.11295L1.59726 1.10753C0.733796 0.719051 -0.228127 1.44632 0.048342 2.2786L2.61324 10Z" fill="#fff"></path><path fillRule="evenodd" clipRule="evenodd" d="M3 10C3 9.44772 3.44772 9 4 9L17 9C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11L4 11C3.44772 11 3 10.5523 3 10Z" fill="#fff"></path></svg> SUBMIT </>
							}
						</button>
					</div>
				</div>


				<Modal show={submitModal.show} size='md' id="successModal" >
					{/* <Modal show={} size='md' id="successModal" > */}
					<div className="modal-content" >
						<div className="modal-body text-center">
							<>
								<h3>Thank you for submitting your query in C.H.E.E.R.</h3>
								<p>Please expect a member of our HR team to contact you shortly.</p>
							</>

						</div>
						<div className="modal-footer">
							<button
								onClick={e => this.closeSubmitModal(e)}
								type="button"
								className="btn btn-primary"
								data-bs-dismiss="modal"
								aria-label="Close"
							>
								<i className="bi bi-x-lg"></i>
							</button>
						</div>
					</div>
				</Modal>

				<Modal show={requiredFieldModal.show} size='md' id="successModal" >
					{/* <Modal show={} size='md' id="successModal" > */}
					<div className="modal-content" >
						<div className="modal-body text-center">
							<>
								<p style={{ fontWeight: 'normal', color: 'black', fontSize: 21 }}>
									All fields marked by red are mandatory.
								</p>
							</>

						</div>
						<div className="modal-footer">
							<button
								onClick={e => this.closeRequiredFieldModal(e)}
								type="button"
								className="btn btn-primary"
								data-bs-dismiss="modal"
								aria-label="Close"
							>
								<i className="bi bi-x-lg"></i>
							</button>
						</div>
					</div>
				</Modal>

				{formErrorModal.show &&
					<Modal show={formErrorModal.show} size='md' id="successModal" >
						{/* <Modal show={} size='md' id="successModal" > */}
						<div className="modal-content" >
							<div className="modal-body">
								{formErrorModal.message}
							</div>
							<div className="modal-footer">
								<button
									onClick={e => this.closeErrorModal(e)}
									type="button"
									className="btn btn-primary"
									data-bs-dismiss="modal"
									aria-label="Close"
								>
									<i className="bi bi-x-lg"></i>
								</button>
							</div>
						</div>
					</Modal>
				}

			</>
		)
			: <Spinner />
	}
}

export default ThirdParty;

